import React, { useCallback, useEffect, useRef, useState } from 'react';
import qs from 'qs';
import { compose } from 'redux';
import debounce from 'lodash/debounce';
import { connect, useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';

import {
  IconSpinner,
  LayoutSingleColumn,
  Page,
  PaginationLinks,
  // PaginationLinks,
  SeeAllGroupModal,
} from '../../components';

import CommunityCard from '../../components/CommunityCard/CommunityCard';
import SekeletonExplore from '../../components/SekeletonExplore/SekeletonExplore';
import { ReactToastify, toastifyFn } from '../../components/ReactToastify/ReactToastify';
import NotificationMobileModal from '../../components/NotificationDropdown/NotificationMobileModal';

import appSettings from '../../config/settings';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import {
  getPublishedDiscoverGroupsCarouselsApi,
  onCreateIntercomTicket,
  onFindGroupJoinRequestCollection,
  onGroupJoinRequestCollection,
} from '../../util/api';
import { checkElephantModalOpen, currentUserRole, getUserPermissions } from '../../util/data';
import { calculateTotalPages, groupSortOptions } from '../../util/circleHelper';
import { createResourceLocatorString, pathByRouteName } from '../../util/routes';
import {
  ACTIVITY,
  DEFAULT_FEED_IMAGE_1200_URL,
  DEFAULT_FEED_IMAGE_600_URL,
  DEFAULT_FEED_IMAGE_URL,
  EXPLORE,
  FEED_TAB,
  LOCAL_STORAGE_CIRCLE_AUTH_TOKEN,
  NOTIFICATION,
  REQUEST_GROUP_PREGRESS,
  REQUEST_JOIN_GROUP_TEMPLATE_ID,
  SAVED_POST,
  communityGorupAccess,
  communityPostAccess,
} from '../../util/types';

import TopbarContainer from '../TopbarContainer/TopbarContainer';

import BookmarkModal from '../CircleCommunityPage/components/BookmarkModal/BookmarkModal';
import EditCommentModal from '../CircleCommunityPage/components/EditCommentModal/EditCommentModal';
import FeedTabs from '../CircleCommunityPage/components/FeedTabs/FeedTabs';
import SideBar from '../CircleCommunityPage/components/FeedTabs/SideBar/SideBar';
import JoinedGroups from '../CircleCommunityPage/components/JoinedGroups/JoinedGroups';
import MobileBottomTabs from '../CircleCommunityPage/components/MobileBottomTabs/MobileBottomTabs';
import ReportContentModal from '../CircleCommunityPage/components/ReportContentModal/ReportContentModal';
import SpaceGroups from '../CircleCommunityPage/components/SpaceGroups/SpaceGroups';
import RequestSpaceModal from '../CircleCommunityPage/components/SpaceGroups/RequestSpaceModal';

import { logout } from '../../ducks/auth.duck';
import { searchGroups } from './GroupSearchPage.duck';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import {
  advancedSearch,
  createSpacePost,
  deleteBookMark,
  fetchBookMarList,
  fetchUserActivity,
  getNotificationPreference,
  getNotificationsCount,
  getNotificationsList,
  markAllNotificationsAsRead,
  markNotificationAsRead,
  setActiveTab,
  joinSpace,
  toggelEditComment,
  toggelRequestSpaceReducer,
  toggleCreatePost,
  toggleReportContent,
  toggleSeeAllGroup,
  updateNotificationPreference,
  requestToJoinGroupNotify,
} from '../CircleCommunityPage/CircleCommunityPage.duck';
import { getGroupShareUrl } from '../../util/groupPageTabRouting';

import FilterOptions from './components/FilterOptions';
import SearchSortingOptions from './components/SearchSortingOptions';
import MobileCategoryFilter from './components/MobileCategoryFilter';

import css from './GroupSearchPage.module.css';
import { setElephantVerificationModal, subscriptionPermissionRequest, requestGroupPermissionModal } from '../../ducks/user.duck';
import CreatePostBar from '../CircleCommunityPage/components/CreatePostBar/CreatePostBar';
import MyActivityModal from '../CircleCommunityPage/components/MyActivity/MyActivityModal';
import { openIntecomOnClickEvents } from '../../components/IntercomComponent/IntercomComponent';
import { useConfiguration } from '../../context/configurationContext';

const GroupSearchPage = props => {
  const dispatch = useDispatch();
  const routeConfiguration = useRouteConfiguration();
  const history = useHistory();
  const config = useConfiguration();
  const intl = useIntl();
  const { keyword: keywordFromUrl, space_group: categoryFromUrl, sort: sortFromUrl } =
    typeof window !== 'undefined' && window && qs.parse(window.location.search.slice(1));

  const [isBookmarkListRequested, setIsBookmarkListRequested] = useState(false);

  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState(keywordFromUrl || '');
  const [isOpen, setIsOpen] = useState(false);
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(categoryFromUrl || '');
  const [isSortingOption, setSortingOption] = useState(sortFromUrl || '');
  const [joiningGroupIds, setJoiningGroupIds] = useState([]);
  const [joinedGroupIds, setJoinedGroupIds] = useState([]);
  const [requestedPrivateGroupIds, setRequestedPrivateGroupIds] = useState([]);
  const [selectedSeeAllCarousel, setSelectedSeeAllCarousel] = useState(null);
  const [isSeeAllGroupsLoading, setIsSeeAllGroupsLoading] = useState(false);
  const hasProcessedRequestGroup = useRef(false);

  const {
    currentCommunityMember,
    spaceListData,
    onDeleteBookMark,
    scrollingDisabled,
    bookmarksListData,
    requestBookmarksList,
    currentUser,
    requestNewSpace,
    isRequestSpace,
    onRequestGroupClick,
    onRequestGroupPermissionModal,
    onSeeAllGroupClick,
    isSeeAllGroup,
    onEditCommentClick,
    editCommentData,
    onToggleCreatePost,
    isReportModal,
    onClickReportModal,
    requestSearchGroups,
    searchGroupsData,
    requestDiscoverGroupsCarousels,
    discoverGroupsCarousels,
    onSearchGroups,
    onJoinSpace,
    onRequestToJoinGroupNotify,
    requestSpaceGroups,
    spaceGroupsData,
    onSetActiveTab,
    activeTab,
    onFetchNotifications,
    onFetchNotificationsCount,
    requestNotificationsInProgress,
    notificationsData,
    onMarkNotificationRead,
    isCreatePost,
    requestDirectUpload,
    onCreateSpacePost,
    advancedSearchData,
    onAdvancedSearch,
    onSubscriptionPermissionRequest,
    loadMoreSearchGroups,
    onManageDisableScrolling,
    requestNotificationPreferenceInProgress,
    notificaitonPreferenceData,
    onGetNotificationPreference,
    onUpdateNotificationPreference,
    onMarkAllNotificationsAsRead,
    onFetchUserActivity,
    fetchUserActivityRequest,
    fetchUserActivityData,
    fetchUserActivityError,
    accessToken,
    isLoggedInAs,
    userModeratorsGroups,
    onSetElephantVerificationModal,
    location
  } = props;

  const isOpenElephantModal = checkElephantModalOpen(currentUser);
  const userNotFound = !accessToken?.success && !!accessToken?.message;

  const isLogin = !!(currentUser && currentUser.id);

  const { roles, id: community_member_id } = currentCommunityMember || {};
  const { page, per_page, has_next_page, count, page_count, records } = searchGroupsData || {};
  const selectedSort = isSortingOption || '';
  const showCarouselBrowse =
    !String(keyword || '').trim() &&
    !String(selectedCategory || '').trim() &&
    !String(selectedSort || '').trim();
  const hasActiveSearchFilters = Boolean(
    String(keyword || '').trim() ||
      String(selectedCategory || '').trim() ||
      String(selectedSort || '').trim()
  );
  const selectedCategoryName = Array.isArray(spaceGroupsData?.records)
    ? spaceGroupsData.records.find(
        item => String(item.id) === String(selectedCategory) || item.slug === selectedCategory
      )?.name
    : '';
  const selectedSortLabel = groupSortOptions.find(option => option.value === selectedSort)?.label;
  const appliedFilterDetails = [
    String(keyword || '').trim() ? `Search: ${String(keyword).trim()}` : null,
    String(selectedCategory || '').trim()
      ? `Category: ${selectedCategoryName || selectedCategory}`
      : null,
    String(selectedSort || '').trim() ? `Sort: ${selectedSortLabel || selectedSort}` : null,
  ].filter(Boolean);
  const appliedFilterLabel =
    appliedFilterDetails.length > 1
      ? `${appliedFilterDetails.length} filters applied`
      : appliedFilterDetails[0] || 'Filter applied';

  const pagination = {
    page: page,
    perPage: 1,
    totalItems: count,
    totalPages: calculateTotalPages(count, per_page),
  };

  const handleIconClick = content => {
    const { tab, pageName, params } = content;

    if (tab === 'MENU') {
      setIsSideBarOpen(tab);
    } else if (tab === 'ADD_MENU') {
      if (isOpenElephantModal && !isCreatePost) {
        onSetElephantVerificationModal(true);
        return;
      };
      if (!checkCreatePostAuth) {
        dispatch(subscriptionPermissionRequest(true));
        return;
      }
      onToggleCreatePost(true);
    }

    else if (tab == "SUPPORT") {
      openIntecomOnClickEvents();
      return;
    }
    else {
      return pageName && history.push(createResourceLocatorString(pageName, routeConfiguration, params, {}))
    }

    // if (tab == EXPLORE) {
    //   setSelectedCategory('');
    //   setKeyword('');
    //   setSortingOption('');
    //   handleTabClick({ tab: EXPLORE, pageName: 'GroupSearchPage' });
    // } else if (tab == NOTIFICATION) {
    //   setIsOpen(true);
    // }
  };

  const closeSideBar = () => {
    setIsSideBarOpen(false);
  };

  const userSubscriptionRole = currentUserRole(currentUser);

  // <<<<<<<<<<<<< all access checked by this fn >>>>>>>>>>>>>>>>>>>>>
  // communityPostAccess >> user can create post or not
  const checkCreatePostAuth = getUserPermissions(userSubscriptionRole, communityPostAccess);
  const checkCreateGroupAuth = getUserPermissions(userSubscriptionRole, communityGorupAccess);

  useEffect(() => {
    if (!location?.search) {
      hasProcessedRequestGroup.current = false;
      return;
    }

    const queryParams = qs.parse(location.search.slice(1));
    const shouldOpenRequestGroup =
      queryParams.requestGroup === 'true' || queryParams.requestGroup === true;

    if (!shouldOpenRequestGroup) {
      hasProcessedRequestGroup.current = false;
      return;
    }

    if (hasProcessedRequestGroup.current || isRequestSpace) {
      return;
    }

    if (!currentUser?.id) {
      return;
    }

    hasProcessedRequestGroup.current = true;

    if (isOpenElephantModal && !isCreatePost) {
      onSetElephantVerificationModal(true);
      return;
    }

    if (!checkCreateGroupAuth) {
      onRequestGroupPermissionModal(true);
      return;
    }

    onRequestGroupClick(true);
  }, [
    checkCreateGroupAuth,
    currentUser?.id,
    isCreatePost,
    isOpenElephantModal,
    isRequestSpace,
    location?.search,
    onRequestGroupClick,
    onRequestGroupPermissionModal,
    onSetElephantVerificationModal,
  ]);

  const onRequestSpace = async values => {
    try {
      setLoading(REQUEST_GROUP_PREGRESS);
      const sendMail = await onCreateIntercomTicket(values);
      toastifyFn('success', 'Request sent successfully');
      return sendMail;
    } catch (e) {
      toastifyFn('error', 'opps something went wrong');
      console.log(e, '&&& &&& => e');
      return e;
    } finally {
      setLoading(false);
      onRequestGroupClick(false);
    }
  };

  const handleTabClick = item => {
    const { tab, pageName } = item;
    if (!isLogin) return history.push(createResourceLocatorString(pageName || "LoginPage", routeConfiguration, {}, {}))
    onSetActiveTab(tab);
    setIsSideBarOpen(false);
    if (tab == SAVED_POST) {
      setIsBookmarkListRequested(true);
      dispatch(fetchBookMarList({}));
    } else if (tab == EXPLORE) {
      setSelectedCategory('');
      setKeyword('');
      setSortingOption('');
      history.push(createResourceLocatorString('GroupSearchPage', routeConfiguration, {}, {}));
    }
    if (tab == ACTIVITY) {
      onFetchUserActivity({ community_member_id, fetchTab: "posts" });
    }
    return (
      pageName && history.push(createResourceLocatorString(pageName, routeConfiguration, {}, {}))
    );
  };

  const pushSearchRoute = searchParams => {
    const queryParams = Object.entries(searchParams || {}).reduce((params, [key, value]) => {
      return value ? { ...params, [key]: value } : params;
    }, {});
    history.push(createResourceLocatorString('GroupSearchPage', routeConfiguration, {}, queryParams));
  };

  const handleSearch = (type, value, nextValues = {}) => {
    const searchParams = type
      ? {
        sort: type === 'sort' ? value : nextValues.sort || isSortingOption,
        space_group:
          type === 'space_group' ? value : nextValues.space_group || selectedCategory,
        keyword: nextValues.keyword !== undefined ? nextValues.keyword : keyword,
      }
      : {};
    // Note: Backend should search keyword across: group name, category name, description, and tags
    onSearchGroups(searchParams);
    pushSearchRoute(searchParams);
  };

  const debouncedSearch = useCallback(
    debounce((value, selectedCategory, isSortingOption) => {
      onSearchGroups({ keyword: value, space_group: selectedCategory, sort: isSortingOption });
      pushSearchRoute({ keyword: value, space_group: selectedCategory, sort: isSortingOption });
    }, 500),
    [history, routeConfiguration]
  );

  const handleClearAllFilters = () => {
    debouncedSearch.cancel?.();
    setSelectedCategory('');
    setKeyword('');
    setSortingOption('');
    handleSearch();
  };

  const handleInputChange = e => {
    const value = e.target.value;
    setKeyword(value);
    debouncedSearch(value, selectedCategory, isSortingOption, spaceGroupsData);
  };

  const NotificationMobileComponent = (
    <NotificationMobileModal
      onFetchNotifications={onFetchNotifications}
      requestNotificationsInProgress={requestNotificationsInProgress}
      notificationsData={notificationsData}
      isOpen={isOpen}
      setIsOpen={() => setIsOpen(false)}
      onMarkNotificationRead={onMarkNotificationRead}
      onManageDisableScrolling={onManageDisableScrolling}
      requestNotificationPreferenceInProgress={requestNotificationPreferenceInProgress}
      notificaitonPreferenceData={notificaitonPreferenceData}
      onGetNotificationPreference={onGetNotificationPreference}
      onUpdateNotificationPreference={onUpdateNotificationPreference}
      onMarkAllNotificationsAsRead={onMarkAllNotificationsAsRead}
      currentUser={currentUser}
    />
  );

  const FilterOptionsComponent = (
    <FilterOptions
      spaceGroups={spaceGroupsData}
      handleSearch={handleSearch}
      setSelectedCategory={setSelectedCategory}
      selectedCategory={selectedCategory}
      closeSideBar={closeSideBar}
      setKeyword={setKeyword}
      setSortingOption={setSortingOption}
    />
  );

  const handlePostCreation = async (apiParams, spaceId) => {
    const response = await onCreateSpacePost(apiParams, spaceId);
    if (response?.id) {
      return history.push(
        createResourceLocatorString('PostViewPage', routeConfiguration, {
          spaceId,
          slug: response?.slug,
          postId: response?.id,
        })
      );
    }
  };

  const MobileCreatePost = (
    <CreatePostBar
      requestDirectUpload={requestDirectUpload}
      currentCommunityMember={currentCommunityMember}
      spaceListData={spaceListData}
      onCreateSpacePost={handlePostCreation}
      isCreatePost={isCreatePost}
      onToggleCreatePost={value => {
        if (isOpenElephantModal && !isCreatePost) {
          onSetElephantVerificationModal(true);
          return;
        };
        checkCreatePostAuth ? onToggleCreatePost(value) : onSubscriptionPermissionRequest(true);
      }}
      advancedSearchData={advancedSearchData}
      onAdvancedSearch={onAdvancedSearch}
      currentUser={currentUser}
    />
  );

  const FeedTabComponent = (
    <FeedTabs
      handleTabClick={handleTabClick}
      activeTab={activeTab}
      checkCreateGroupAuth={checkCreateGroupAuth}
      onRequestGroupClick={onRequestGroupClick}
      onRequestGroupPermissionModal={onRequestGroupPermissionModal}
      userNotFound={userNotFound}
      isLoggedInAs={isLoggedInAs}
      currentUser={currentUser}
    />
  );

  const SpaceGroupsComponent = (
    <SpaceGroups
      spaceListData={spaceListData}
      history={history}
      routeConfiguration={routeConfiguration}
      requestNewSpace={requestNewSpace}
      isRequestSpace={isRequestSpace}
      onRequestGroupClick={onRequestGroupClick}
      onSetActiveTab={onSetActiveTab}
      checkCreatePostAuth={checkCreatePostAuth}
      userModeratorsGroups={userModeratorsGroups}
    />
  );

  const JoinedGroupsComponent = (
    <JoinedGroups
      history={history}
      routeConfiguration={routeConfiguration}
      spaceListData={spaceListData}
      isRequestSpace={isRequestSpace}
      onRequestGroupClick={onRequestGroupClick}
      onSetActiveTab={onSetActiveTab}
      checkCreatePostAuth={checkCreatePostAuth}
      userModeratorsGroups={userModeratorsGroups}
    />
  );

  const mobileBottomTabsComponent = <MobileBottomTabs currentUser={currentUser} handleIconClick={handleIconClick} selectedTab={"COMMUNITY"} />;

  const handleLogout = () => {
    const { onLogout } = props;
    onLogout().then(() => {
      const path = pathByRouteName('LandingPage', routeConfiguration);

      try {
        if (typeof window !== 'undefined') {
          localStorage.removeItem(LOCAL_STORAGE_CIRCLE_AUTH_TOKEN);
        }
      } catch (e) { }

      // In production we ensure that data is really lost,
      // but in development mode we use stored values for debugging
      if (appSettings.dev) {
        history.push(path);
      } else if (typeof window !== 'undefined') {
        window.location = path;
      }

      console.log('logged out'); // eslint-disable-line
    });
  };

  const handleLoadMore = () => {
    const params = {
      page: page + 1,
      sort: isSortingOption,
      keyword: keyword,
      space_group: selectedCategory,
    };
    onSearchGroups(params);
  };

  const getGroupId = group => Number(group?.groupId || group?.id);

  const getSpaceListRecords = () => {
    if (Array.isArray(spaceListData?.records)) return spaceListData.records;
    if (Array.isArray(spaceListData)) return spaceListData;
    return [];
  };

  const isKnownMember = group => {
    const groupId = getGroupId(group);
    if (!Number.isFinite(groupId)) return false;
    if (joinedGroupIds.includes(groupId)) return true;
    const matchedSpace = getSpaceListRecords().find(space => Number(space?.id) === groupId);
    return Boolean(matchedSpace?.is_member || group?.is_member);
  };

  const handleJoinGroup = async groupId => {
    const numericGroupId = Number(groupId);
    if (!Number.isFinite(numericGroupId) || joiningGroupIds.includes(numericGroupId)) return;

    if (!isLogin) {
      history.push(createResourceLocatorString('LoginPage', routeConfiguration, {}, {}));
      return;
    }

    try {
      setJoiningGroupIds(ids => [...ids, numericGroupId]);
      const response = await onJoinSpace(numericGroupId);
      if (!response?.error) {
        setJoinedGroupIds(ids => (ids.includes(numericGroupId) ? ids : [...ids, numericGroupId]));
      }
    } finally {
      setJoiningGroupIds(ids => ids.filter(id => id !== numericGroupId));
    }
  };

  const isPrivateGroup = group => {
    const visibility = String(group?.visibility || group?.space_type || group?.type || '').toLowerCase();
    return Boolean(
      group?.is_private ||
        group?.is_secret ||
        group?.is_hidden_from_non_members ||
        visibility.includes('private') ||
        visibility.includes('secret')
    );
  };

  const getVisiblePrivateGroups = () => {
    const carouselGroups = Array.isArray(discoverGroupsCarousels)
      ? discoverGroupsCarousels.flatMap(carousel =>
          Array.isArray(carousel.groups) ? carousel.groups : []
        )
      : [];
    const searchRecords = Array.isArray(records) ? records : [];
    const groupsById = [...carouselGroups, ...searchRecords].reduce((map, group) => {
      const groupId = getGroupId(group);
      if (Number.isFinite(groupId) && isPrivateGroup(group)) {
        map[groupId] = group;
      }
      return map;
    }, {});

    return Object.values(groupsById);
  };

  const handleRequestToJoinPrivateGroup = async group => {
    const numericGroupId = getGroupId(group);
    if (!Number.isFinite(numericGroupId) || requestedPrivateGroupIds.includes(numericGroupId)) {
      return;
    }

    if (!isLogin) {
      history.push(createResourceLocatorString('LoginPage', routeConfiguration, {}, {}));
      return;
    }

    if (isOpenElephantModal) {
      onSetElephantVerificationModal(true);
      return;
    }

    const { firstName, lastName } = currentUser?.attributes?.profile || {};
    const userEmail = currentUser?.attributes?.email;
    const groupSlug = group?.groupSlug || group?.slug;
    const groupName = group?.groupName || group?.name;
    const values = {
      data: {
        userName: `${firstName || ''} ${lastName || ''}`.trim(),
        userEmail,
        groupName,
        groupId: numericGroupId,
        userId: currentUser?.id?.uuid,
        viewRequestURL: getGroupShareUrl(groupSlug, numericGroupId, config?.marketplaceRootURL),
      },
      template_id: REQUEST_JOIN_GROUP_TEMPLATE_ID,
    };

    try {
      setJoiningGroupIds(ids => [...ids, numericGroupId]);
      const response = await onGroupJoinRequestCollection(values);
      if (response?.data) {
        await onRequestToJoinGroupNotify(values);
        setRequestedPrivateGroupIds(ids =>
          ids.includes(numericGroupId) ? ids : [...ids, numericGroupId]
        );
        toastifyFn('success', 'Request sent successfully');
      } else if (typeof response?.message === 'string') {
        setRequestedPrivateGroupIds(ids =>
          ids.includes(numericGroupId) ? ids : [...ids, numericGroupId]
        );
        toastifyFn('info', response.message);
      } else {
        toastifyFn('error', 'Oops! Something went wrong');
      }
    } catch {
      toastifyFn('error', 'Oops! Something went wrong');
    } finally {
      setJoiningGroupIds(ids => ids.filter(id => id !== numericGroupId));
    }
  };

  const membershipCardProps = group => {
    const groupId = getGroupId(group);
    const isPrivate = isPrivateGroup(group);
    return {
      showMembershipActions: true,
      isMember: isKnownMember(group),
      isJoinPending: joiningGroupIds.includes(groupId) || requestedPrivateGroupIds.includes(groupId),
      joinButtonLabel: isPrivate ? 'Ask To Join' : 'Join Now',
      joinPendingLabel: isPrivate ? 'Pending' : 'Joining...',
      onJoin: () => (isPrivate ? handleRequestToJoinPrivateGroup(group) : handleJoinGroup(groupId)),
    };
  };

  useEffect(() => {
    const email = currentUser?.attributes?.email;
    if (!email) return;

    const privateGroupsToCheck = getVisiblePrivateGroups().filter(group => {
      const groupId = getGroupId(group);
      return Number.isFinite(groupId) && !requestedPrivateGroupIds.includes(groupId);
    });

    if (!privateGroupsToCheck.length) return;

    let isCancelled = false;
    Promise.all(
      privateGroupsToCheck.map(group =>
        onFindGroupJoinRequestCollection({
          email,
          spaceId: getGroupId(group),
        }).catch(() => null)
      )
    ).then(responses => {
      if (isCancelled) return;

      const pendingGroupIds = responses
        .map(response => (response?.status === 'pending' ? Number(response.spaceId) : null))
        .filter(Number.isFinite);

      if (pendingGroupIds.length) {
        setRequestedPrivateGroupIds(ids => [...new Set([...ids, ...pendingGroupIds])]);
      }
    });

    return () => {
      isCancelled = true;
    };
  }, [currentUser, discoverGroupsCarousels, records, requestedPrivateGroupIds]);

  const scrollCarousel = (carouselId, direction) => {
    if (typeof document === 'undefined') return;
    const carouselNode = document.getElementById(`discover-groups-carousel-${carouselId}`);
    if (!carouselNode) return;
    carouselNode.scrollBy({
      left: direction === 'next' ? 360 : -360,
      behavior: 'smooth',
    });
  };

  const handleSeeAllCarouselClick = async carousel => {
    setSelectedSeeAllCarousel(carousel);
    if (!isSeeAllGroup) {
      onSeeAllGroupClick();
    }

    try {
      setIsSeeAllGroupsLoading(true);
      const response = await getPublishedDiscoverGroupsCarouselsApi();
      const latestCarousel = response?.data?.find(item => item.id === carousel.id);
      if (latestCarousel) {
        setSelectedSeeAllCarousel(latestCarousel);
      }
    } catch (error) {
      console.warn('[GroupSearchPage] Unable to refresh See All groups', error);
    } finally {
      setIsSeeAllGroupsLoading(false);
    }
  };

  const handleCloseSeeAllGroups = () => {
    setSelectedSeeAllCarousel(null);
    setIsSeeAllGroupsLoading(false);
    onSeeAllGroupClick();
  };

  const toCommunityCardData = group => ({
    ...group,
    id: group.groupId || group.id,
    slug: group.groupSlug || group.slug,
    name: group.groupName || group.name,
  });

  const desktopCategoryChips = (
    <div className={css.categoryChips}>
      <button
        type="button"
        className={!selectedCategory ? css.selectedCategoryChip : css.categoryChip}
        onClick={handleClearAllFilters}
      >
        All
      </button>
      {Array.isArray(spaceGroupsData?.records)
        ? spaceGroupsData.records
          .filter(item => item.id !== 615609)
          .slice(0, 8)
          .map(item => {
            const categoryId = String(item.id);
            return (
              <button
                type="button"
                key={item.id}
                className={
                  String(selectedCategory) === categoryId
                    ? css.selectedCategoryChip
                    : css.categoryChip
                }
                onClick={() => {
                  setSelectedCategory(categoryId);
                  handleSearch('space_group', categoryId);
                }}
              >
                {item.name}
              </button>
            );
          })
        : null}
    </div>
  );
const [scrolledCarousels, setScrolledCarousels] = useState({});

const handleCarouselScroll = (carouselId, e) => {
  const scrollLeft = e.target.scrollLeft;
  setScrolledCarousels(prev => {
    const isScrolled = scrollLeft > 10; // small threshold to avoid flicker at 0
    if (prev[carouselId] === isScrolled) return prev; // avoid unnecessary re-renders
    return { ...prev, [carouselId]: isScrolled };
  });
};
  const discoverGroupsCarouselContent = requestDiscoverGroupsCarousels ? (
    <SekeletonExplore />
  ) : Array.isArray(discoverGroupsCarousels) && discoverGroupsCarousels.length > 0 ? (
    <div className={css.carouselBrowse}>
      {discoverGroupsCarousels.map(carousel => {
        const carouselGroups = Array.isArray(carousel.groups) ? carousel.groups : [];
        if (!carouselGroups.length) return null;

        return (
          <section className={css.carouselSection} key={carousel.id}>
            <div className={css.carouselHeader}>
              <h2>{carousel.label}</h2>
              {carouselGroups.length > 1 ? (
                <div className={css.carouselHeaderActions}>
                  {carouselGroups.length > 3 ? (
                    <button
                      type="button"
                      className={css.seeAllButton}
                      onClick={() => handleSeeAllCarouselClick(carousel)}
                    >
                      See All
                    </button>
                  ) : null}
                  <button
                    type="button"
                    className={css.seeAllButtonMobile}
                    onClick={() => handleSeeAllCarouselClick(carousel)}
                  >
                    See All
                  </button>
                  {carouselGroups.length > 3 ? (
                    <>
                      <button
                        type="button"
                        className={css.carouselArrowLeft}
                        aria-label="Previous groups"
                        disabled={!scrolledCarousels[carousel.id]}
                        onClick={() => scrollCarousel(carousel.id, 'prev')}
                      >
                        <ChevronLeft aria-hidden="true" />
                      </button>
                      <button
                        type="button"
                        className={css.carouselArrow}
                        aria-label="Next groups"
                        onClick={() => scrollCarousel(carousel.id, 'next')}
                      >
                        <ChevronRight aria-hidden="true" />
                      </button>
                    </>
                  ) : null}
                </div>
              ) : null}
            </div>
            <div className={css.carouselBody}>
              <div
                id={`discover-groups-carousel-${carousel.id}`}
                className={css.carouselTrack}
                onScroll={e => handleCarouselScroll(carousel.id, e)}
              >
                {carouselGroups.map(group => (
                  <CommunityCard
                    key={`${carousel.id}-${group.id || group.groupId}`}
                    className={css.carouselCard}
                    data={toCommunityCardData(group)}
                    buttonTextId={'CircleSearchPage.groupCardButton'}
                    {...membershipCardProps(group)}
                  />
                ))}
              </div>
            </div>
          </section>
        );
      })}
    </div>
  ) : (
    <div className={css.noResultText}>
      <FormattedMessage id="CircleFeedPage.noSearchResults" />
    </div>
  );

  // Seo optimaization
  const schemaTitle = intl.formatMessage({ id: 'GroupSearchPage.schemaTitle' });
  const description = intl.formatMessage({ id: 'GroupSearchPage.schemaDescription' });
  const pageURL = `${config?.marketplaceRootURL}${location?.pathname}${location?.search}${location?.hash}`;
  const pageImageURL = [DEFAULT_FEED_IMAGE_URL];
  const socialSharingImages1200 = [
    {
      "height": 630,
      "width": 1200,
      "url": DEFAULT_FEED_IMAGE_1200_URL,
      "name": ""
    }
  ];
  const socialSharingImages600 = [{
    "height": 314,
    "width": 600,
    "url": DEFAULT_FEED_IMAGE_600_URL,
    "name": ""
  }];

  const socialSharing = {
    title: schemaTitle,
    description: description,
    images1200: socialSharingImages1200,
    images600: socialSharingImages600,
  };



  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      title={schemaTitle}
      description={description}
      socialSharing={socialSharing}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Organization',
        description: description,
        name: schemaTitle,
        image: pageImageURL,
        url: pageURL,
      }}
      className={css.pageRoot}
    >
      <LayoutSingleColumn
        className={css.pageWrapper}
        topbar={
          <>
            <TopbarContainer
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
              currentPage={"GroupSearchPage"}
            />
          </>
        }
      // footer={<FooterComponent />}
      >
        <>
          <div className={css.leftSideNav}>
            {FeedTabComponent}
            <button
              className={css.createPostButton}
              onClick={() => {
                if (isOpenElephantModal && !isCreatePost) {
                  onSetElephantVerificationModal(true);
                  return;
                }
                if (!checkCreatePostAuth) {
                  dispatch(subscriptionPermissionRequest(true));
                  return;
                }
                onToggleCreatePost(true);
              }}
            >
              + Create Post
            </button>
            {(SpaceGroupsComponent || JoinedGroupsComponent) && <div className={css.spacer}></div>}
            {SpaceGroupsComponent}
            {JoinedGroupsComponent}
          </div>

          <div className={css.rightSideWrapper}>
            {/* header */}
            {/* results count */}
            <div className={css.rightSideContent}>
              {/* show create post for mobile */}
              {isCreatePost ? MobileCreatePost : null}
              <div className={css.topResultContainer}>
                <div className={css.resultHeading}>
                  {showCarouselBrowse ? (
                    <span>Discover Groups</span>
                  ) : (
                    <FormattedMessage id="CircleSearchPage.results" />
                  )}
                  {!showCarouselBrowse && per_page && count ? (
                    <div className={css.countDetails}>{records?.length}</div>
                  ) : null}
                </div>
                {/* search bar */}
                <div className={css.topSearchContainer}>
                  <div className={css.inputBox}>
                    <input
                      type="text"
                      placeholder="Search groups by name"
                      value={keyword}
                      onChange={e => handleInputChange(e)}
                    />
                  </div>
                  {/* mobile category filter */}
                  <div className={css.filterOptions}>
                    <MobileCategoryFilter
                      spaceGroups={spaceGroupsData}
                      handleSearch={handleSearch}
                      setSelectedCategory={setSelectedCategory}
                      selectedCategory={selectedCategory}
                      setKeyword={setKeyword}
                      setSortingOption={setSortingOption}
                    />
                    {/* sorting options */}
                    <SearchSortingOptions
                      sortingOptions={groupSortOptions}
                      handleFilterOptions={option => handleSearch('sort', option)}
                      sort={isSortingOption}
                      setSortingOption={setSortingOption}
                    />
                  </div>
                  {hasActiveSearchFilters ? (
                    <button
                      type="button"
                      className={css.clearFilterButton}
                      onClick={handleClearAllFilters}
                      aria-label="Clear applied filters"
                    >
                      <span className={css.appliedFilterText}>{appliedFilterLabel}</span>
                      <X className={css.clearFilterIcon} aria-hidden="true" />
                    </button>
                  ) : null}
                </div>
                {desktopCategoryChips}
              </div>
              {/* search results */}

              {showCarouselBrowse ? (
                discoverGroupsCarouselContent
              ) : requestSearchGroups ? (
                <SekeletonExplore />
              ) : Array.isArray(records) ? (
                <InfiniteScroll
                  hasMore={has_next_page}
                  next={() => handleLoadMore()}
                  dataLength={(records && records.length) || per_page}
                  className={css.listingCards}
                >
                  <div className={css.communityCardWrapper}>
                    {records?.map(item => (
                      <CommunityCard
                        key={item.id}
                        data={item}
                        buttonTextId={'CircleSearchPage.groupCardButton'}
                        {...membershipCardProps(item)}
                      />
                    ))}
                  </div>
                </InfiniteScroll>
              ) : null}
              {loadMoreSearchGroups ? (
                <div className={css.spinnerWrapper}>
                  <IconSpinner type={true} />
                </div>
              ) : null}
              {!showCarouselBrowse && !requestSearchGroups && records?.length === 0 ? (
                <div className={css.noResultText}>
                  <FormattedMessage id="CircleFeedPage.noSearchResults" />
                </div>
              ) : null}

              {/* page no's */}
              {/* {records?.length > 0 ? (
                <div className={css.paginationSection}>
                  <PaginationLinks
                    pageName="GroupSearchPage"
                    // pagePathParams={params}
                    pagination={pagination}
                  />
                </div>
              ) : null} */}

              {isBookmarkListRequested ? (
                <BookmarkModal
                  requestBookmarksList={requestBookmarksList}
                  isBookmarkListRequested={isBookmarkListRequested}
                  setIsBookmarkListRequested={setIsBookmarkListRequested}
                  bookmarksListData={bookmarksListData}
                  onDeleteBookMark={onDeleteBookMark}
                  history={history}
                  routeConfiguration={routeConfiguration}
                  spaceListData={spaceListData}
                  onManageDisableScrolling={onManageDisableScrolling}
                  onSetActiveTab={() => onSetActiveTab(EXPLORE)}
                />
              ) : null}
              <MyActivityModal
                isMyActivity={activeTab == ACTIVITY}
                onManageDisableScrolling={onManageDisableScrolling}
                onSetActiveTab={() => onSetActiveTab(EXPLORE)}
                onFetchUserActivity={onFetchUserActivity}
                fetchUserActivityRequest={fetchUserActivityRequest}
                fetchUserActivityData={fetchUserActivityData}
                fetchUserActivityError={fetchUserActivityError}
                routeConfiguration={routeConfiguration}
                history={history}
                currentCommunityMember={currentCommunityMember}
              />

              <RequestSpaceModal
                isRequestSpace={isRequestSpace}
                onRequestGroupClick={() => onRequestGroupClick(false)}
                spaceListData={spaceListData}
                requestNewSpace={requestNewSpace}
                currentUser={currentUser}
                onRequestSpace={onRequestSpace}
                onManageDisableScrolling={onManageDisableScrolling}
                loading={loading}
              />
              <SeeAllGroupModal
                onSeeAllGroupClick={handleCloseSeeAllGroups}
                isSeeAllGroup={isSeeAllGroup}
                spaceListData={spaceListData}
                title={selectedSeeAllCarousel?.label}
                groups={selectedSeeAllCarousel?.groups}
                isLoading={isSeeAllGroupsLoading}
                getCardData={toCommunityCardData}
                getMembershipCardProps={membershipCardProps}
                buttonTextId="CircleSearchPage.groupCardButton"
                history={history}
                routeConfiguration={routeConfiguration}
                onManageDisableScrolling={onManageDisableScrolling}
              />
              <EditCommentModal
                onEditCommentClick={onEditCommentClick}
                editCommentData={editCommentData}
                onManageDisableScrolling={onManageDisableScrolling}
              />
              <ReportContentModal
                isReportModal={isReportModal}
                onClickReportModal={onClickReportModal}
                onManageDisableScrolling={onManageDisableScrolling}
                currentUser={currentUser}
              />
            </div>
          </div>
          {NotificationMobileComponent}
          {currentUser && currentUser?.id ? mobileBottomTabsComponent : null}
          <SideBar
            isOpen={isSideBarOpen}
            onClose={closeSideBar}
            FeedTabComponent={FeedTabComponent}
            FilterOptionsComponent={FilterOptionsComponent}
            // SpaceGroupsComponent={SpaceGroupsComponent}
            // JoinedGroupsComponent={JoinedGroupsComponent}
            // DiscoverGroupsComponent={DiscoverGroupsComponent}
            onLogout={handleLogout}
            currentPage={'GroupSearchPage'}
            currentUser={currentUser}
          />
          <ReactToastify />
        </>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { isAuthenticated, isLoggedInAs } = state.auth;
  const {
    currentUser,
    currentUserHasListings,
    currentUserNotificationCount: notificationCount,
    requestGroupPermissionModal,
    userModeratorsGroups,
  } = state.user;
  const {
    requestSearchGroups,
    searchGroupsData,
    requestSpaceGroups,
    spaceGroupsData,
    loadMoreSearchGroups,
    accessToken,
    requestDiscoverGroupsCarousels,
    discoverGroupsCarousels,
  } = state.GroupSearchPage;
  const {
    currentCommunityMember,
    spaceListData,
    bookmarksListData,
    requestBookmarksList,
    requestNewSpace,
    isRequestSpace,
    isSeeAllGroup,
    editCommentData,
    isReportModal,
    activeTab,
    requestNotificationsInProgress,
    notificationsData,
    isCreatePost,
    requestDirectUpload,
    advancedSearchData,
    requestNotificationPreferenceInProgress,
    notificaitonPreferenceData,
    onFetchUserActivity,
    fetchUserActivityRequest,
    fetchUserActivityData,
    fetchUserActivityError,
  } = state.CircleCommunityPage;
  return {
    isAuthenticated,
    currentUser,
    requestGroupPermissionModal,
    currentUserHasListings,
    notificationCount,
    currentCommunityMember,
    spaceListData,
    scrollingDisabled: isScrollingDisabled(state),
    bookmarksListData,
    requestBookmarksList,
    requestNewSpace,
    isRequestSpace,
    isSeeAllGroup,
    editCommentData,
    isReportModal,
    requestSearchGroups,
    searchGroupsData,
    requestSpaceGroups,
    spaceGroupsData,
    activeTab,
    requestNotificationsInProgress,
    notificationsData,
    isCreatePost,
    requestDirectUpload,
    advancedSearchData,
    loadMoreSearchGroups,
    requestNotificationPreferenceInProgress,
    notificaitonPreferenceData,
    onFetchUserActivity,
    fetchUserActivityRequest,
    fetchUserActivityData,
    fetchUserActivityError,
    accessToken,
    requestDiscoverGroupsCarousels,
    discoverGroupsCarousels,
    userModeratorsGroups,
    isLoggedInAs
  };
};

const mapDispatchToProps = dispatch => ({
  onDeleteBookMark: apiParams => dispatch(deleteBookMark(apiParams)),
  onRequestGroupPermissionModal: type => dispatch(requestGroupPermissionModal(type)),
  onRequestGroupClick: value => dispatch(toggelRequestSpaceReducer(value)),
  onSeeAllGroupClick: () => dispatch(toggleSeeAllGroup()),
  onEditCommentClick: () => dispatch(toggelEditComment()),
  onToggleCreatePost: () => dispatch(toggleCreatePost()),
  onClickReportModal: () => dispatch(toggleReportContent()),
  onLogout: historyPush => dispatch(logout(historyPush)),
  onSearchGroups: apiParams => dispatch(searchGroups(apiParams)),
  onJoinSpace: spaceId => dispatch(joinSpace(spaceId)),
  onRequestToJoinGroupNotify: params => dispatch(requestToJoinGroupNotify(params)),
  onSetActiveTab: tab => dispatch(setActiveTab(tab)),
  onFetchNotifications: () => dispatch(getNotificationsList()),
  onFetchNotificationsCount: () => dispatch(getNotificationsCount()),
  onMarkNotificationRead: id => dispatch(markNotificationAsRead(id)),
  onCreateSpacePost: (apiParams, spaceId, postId) =>
    dispatch(createSpacePost(apiParams, spaceId, postId)),
  onAdvancedSearch: params => dispatch(advancedSearch(params)),
  onSubscriptionPermissionRequest: type => dispatch(subscriptionPermissionRequest(type)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onMarkAllNotificationsAsRead: () => dispatch(markAllNotificationsAsRead()),
  onGetNotificationPreference: () => dispatch(getNotificationPreference()),
  onUpdateNotificationPreference: params => dispatch(updateNotificationPreference(params)),
  onFetchUserActivity: (params) => dispatch(fetchUserActivity(params)),
  onSetElephantVerificationModal: (params) => dispatch(setElephantVerificationModal(params)),
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GroupSearchPage);
